import { Color, Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { FontWeight } from 'design-system/variables/text';

interface GraphExplorerPanelItemProps {
  label: string;
  children?: ReactNode;
}

const HeadingContainer = styled('div')`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
`;

const Body = styled('section')`
  padding: ${Spacing[2]} 0;
  font-size: ${({ theme }) => {
    return theme.fontSizeSmall;
  }};
`;

const PanelItemContainer = styled('div')`
  padding: ${Spacing[4]} ${Spacing[4]};
  flex: none;
  display: flex;
  flex-direction: column;

  overflow-y: auto;
  overflow-x: hidden;
  border-bottom: 1px solid ${Color.CoreSlate100};
`;

const GraphExplorerPanelItem = ({ label, children }: GraphExplorerPanelItemProps) => {
  return (
    <PanelItemContainer>
      <HeadingContainer>{label}</HeadingContainer>
      <Body>{children}</Body>
    </PanelItemContainer>
  );
};

export default Object.assign(GraphExplorerPanelItem, { Body });
